import React from "react";
import { Translate } from "orion-components/i18n";

const roleFailoverBuilder = () => {
	return (
		<div id="rule-statement" className="cb-font-b9">
			<Translate value="global.ruleBuilder.roleFailover.alarmMe" />
		</div>
	);
};

export default roleFailoverBuilder;
